module.exports = {"320311001":"王陵街道","320311002":"七里沟街道","320311003":"永安街道","320311004":"湖滨街道","320311005":"段庄街道","320311006":"翟山街道","320311007":"奎山街道","320311008":"和平街道","320311009":"金山街道","320311010":"泰山街道","320311011":"庞庄街道","320311012":"火花街道","320311013":"桃园街道","320311014":"苏山街道","320311401":"徐州泉山经济开发区","320311402":"徐州软件园管理委员会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320311.json
// module id = 851
// module chunks = 0